/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LoanInstallmentPaymentFeeApiModel } from './loan-installment-payment-fee';

export interface LoanInstallmentPaymentApiModel {
  /**
   * Installment payment principal amount
   */
  amount?: number | null;
  /**
   * Number of decimal digits in amount value
   */
  amount_decimal_digits?: number | null;
  /**
   * Automatic debit/repayment of the installment payment
   */
  automatic?: number | null;
  /**
   * Notifying the Client about the processing status installment payment
   */
  client_notifications?: number | null;
  /**
   * Comment of the non-automatic installment payment (optional)
   */
  comment?: string | null;
  /**
   * Installment payment commission fee amount (readonly)
   */
  commission_amount?: number | null;
  fees?: Array<LoanInstallmentPaymentFeeApiModel>;
  /**
   * Installment payment ID (readonly)
   */
  id?: string | null;
  /**
   * Loan ID (readonly)
   */
  loan_id?: string | null;
  /**
   * Installment payment number (readonly)
   */
  number?: number | null;
  /**
   * Overdraft allowed for debit/repayment of the installment payment (optional)
   */
  overdraft?: number | null;
  /**
   * Preliminary Transaction Id (optional, only for first installment payment) (optional)
   */
  preliminary_transaction_id?: string | null;
  /**
   * Installment payment processed date and time (readonly) (optional)
   */
  processed?: string | null;
  /**
   * Installment payment processed by (readonly) (optional)
   */
  processed_by?: LoanInstallmentPaymentApiModelProcessedByEnum | null;
  /**
   * Operation of an early loan payment flag (readonly) (optional)
   */
  processed_early?: number | null;
  /**
   * Scheduled date of the automatic installment payment (optional)
   */
  scheduled_date?: string | null;
  /**
   * Installment payment status (readonly)
   */
  status?: LoanInstallmentPaymentApiModelStatusEnum | null;
  /**
   * Installment payment total amount including principal and commission fee (readonly)
   */
  total_amount?: number | null;
  /**
   * Transaction Id (Finalized transaction Id) (readonly) (optional)
   */
  transaction_id?: string | null;
}
export enum LoanInstallmentPaymentApiModelProcessedByEnum {
  System = 'system',
  Business = 'business',
  Customer = 'customer'
}
export enum LoanInstallmentPaymentApiModelStatusEnum {
  Created = 'created',
  Processed = 'processed',
  Failed = 'failed'
}
